import styled from 'styled-components'

// NAV BAR BACKGROUND SCROLL IMAGE
export const NavBarBackgroundImage = styled.div`
  background: url(${props => props.backgroundUrl});
  background-repeat: repeat-y;
  bottom: 0.25em;
  left: 0.25em;
  position: absolute;
  top: 0.25em;
  width: 2em;
  z-index: 100;
  @media (min-width: 1280px) {
    width: 4.5em;
  }
  @media (max-width: 759px) {
    display: none;
  }
`

// BACKGROUND COLOR
//default light-grey #f5f5f5
export const DivWithBackgroundColor = styled.div`
  background-color: ${props => props.backgroundColor || '#f5f5f5'};
  position: relative;
`

export const DivHeroMask = styled.div`
  height: 110%;
  background: transparent;   

  @media (min-width: 760px) and (max-width: 1024px) {
    background: ${props => props.backgroundColor || '#f5f5f5'} 
  }

  @media (min-width: 1024px) and (max-width: 1280px) {
    background: ${props => props.backgroundColor || '#f5f5f5'} 
  }

  @media (min-width: 1280px) {
    background: ${props => props.backgroundColor || '#f5f5f5'} 
  }

  &:before {
    background: ${props => props.backgroundColor || '#f5f5f5'} 
    content: " ";
    position: absolute;
    height: 110%;
    top: 0;
    left: 0;
    width: 4.3125em;
  
    @media (min-width: 760px) and (max-width: 1279px) {
      width: 10em;
    }

    @media (min-width: 1280px) {
      width: 13em;
    }
  }
`

// ALL PRIMARY COLORS
// default black #000

export const PrimaryDiv = styled.div`
  color: ${props => props.primaryTextColor || '#000'};
`

export const PrimaryH3 = styled.h3`
  color: ${props => props.primaryTextColor || '#000'};
`

export const PrimaryH2 = styled.h2`
  color: ${props => props.primaryTextColor || '#000'};
`
export const PrimaryQ = styled.q`
  color: ${props => props.primaryTextColor || '#000'};
`

// ALL SECONDARY COLORS
// default grey #8f8f8f

export const SecondaryP = styled.p`
  color: ${props => props.secondaryTextColor || '#8f8f8f'} !important;
`

export const SecondaryLi = styled.li`
  color: ${props => props.secondaryTextColor || '#8f8f8f'} !important;
`

export const SecondaryDivBorder = styled.div`
  border-top: 1px solid ${props => props.secondaryBorderTopColor || '#8f8f8f'} !important;
`

//  MULTIPLE PROP COLORS

// header tags h3 is primary, li is secondary
export const StyledTagSection = styled.section`
  h3 {
    color: ${props => props.primaryTextColor || '#000'};
  }
  li {
    color: ${props => props.secondaryTextColor || '#8f8f8f'};
  }
`

// pannel primarytext is primary, '+' button is secondary, on hover primary
export const StyledPanelButton = styled.button`
  color: ${props => props.primaryTextColor || '#000'};

  &:before,
  &:after {
    background-color: ${props => props.xButtonSecondary || '#8f8f8f'};
  }

  &:hover {
    &:before,
    &:after {
      content: '';
      background-color: ${props => props.xButtonPrimary || '#000'};
    }
  }
`

// carousle arrow buttons is secondary, on hover is primary
export const StyledArrowDiv = styled.div`
  svg #arrow-button {
    stroke: ${props => props.secondaryStrokeColor || '#8f8f8f'};
  }

  &:hover {
    svg #arrow-button {
      stroke: ${props => props.primaryStrokeColor || '#000'};
    }
  }
`

// link is secondary, on hover is primary
export const StyledA = styled.a`
  color: ${props => props.secondaryTextColor || '#8f8f8f'} !important;

  &:hover {
    color: ${props => props.primaryTextColor || '#000'} !important;
  }
`

// footer links are primary, on hover secondary. left col is all secondary except company name.
export const StyledFooter = styled.footer`
  background-color: ${props => props.backgroundColor || '#f5f5f5'};

  ul > li {
    color: ${props => props.primaryTextColor || '#000'};
    a:hover {
      color: ${props => props.secondaryTextColor || '#8f8f8f'};
    }
  }

  p {
    color: ${props => props.secondaryTextColor || '#8f8f8f'};
  }

  .airlift > p:nth-child(1) {
    color: ${props => props.primaryTextColor || '#8f8f8f'};
  }
`

export const ColorOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: ${props => props.hoverColor || 'transparent'};
`

export const BlockTitle = styled.h2`
  color: ${props => props.textColor || '#000'};
`

export const BlockCopy = styled.p`
  color: ${props => props.textColor || '#000'};

  a {
    &:hover {
      color: ${props => props.hoverColor || '#8f8f8f'};
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/shared-page-components/styled-components.js